module.exports = __webpack_public_path__ + "static/media/mozart.52665814.wav";